module.exports = __webpack_public_path__ + "static/media/logo_white.18b8a256.svg";